/**
 * EnrollmentStatusBadge
 *
 * Status pill for enrollment lifecycle. Mantine Badge; colors from EnrollmentStatusColors.
 * PHI-safe: status only.
 */

import { Badge } from '@mantine/core';
import type { EnrollmentStatus } from '../types';
import { EnrollmentStatusColors, EnrollmentStatusLabels } from '../types';

interface EnrollmentStatusBadgeProps {
  status: EnrollmentStatus;
  size?: 'xs' | 'sm' | 'md' | 'lg';
  variant?: 'light' | 'filled' | 'outline';
}

export function EnrollmentStatusBadge({
  status,
  size = 'sm',
  variant = 'light',
}: EnrollmentStatusBadgeProps): JSX.Element {
  const color = EnrollmentStatusColors[status];
  const label = EnrollmentStatusLabels[status];
  return (
    <Badge size={size} variant={variant} color={color}>
      {label}
    </Badge>
  );
}
